import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProductsNew = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M38.85 9.15 24 3 9.15 9.15 3 24l6.15 14.85L24 45l14.85-6.15L45 24zm-12.6 17.1v7.5h-4.5v-7.5h-7.5v-4.5h7.5v-7.5h4.5v7.5h7.5v4.5z" })
});
export default SvgProductsNew;
